export default __webpack_public_path__ + "static/media/search-button.34fc80dc.svg";